// Sign-up CTA card for signed-out users on the want ad detail sidebar
import React from "react";

const SignedOutIntroCTA = ({ onGetStarted }) => {
  return (
    <div className="signed-out-intro-cta">
      <h3 className="signed-out-intro-cta__heading">
        Skip the Daily Scroll
      </h3>
      <p className="signed-out-intro-cta__body">
        Sign up to get alerted when a buyer is looking for a property like yours.
      </p>
      <button
        className="btn signed-out-intro-cta__btn"
        onClick={onGetStarted}
      >
        Get Started
      </button>
      <p className="signed-out-intro-cta__footnote">
        No need to browse the feed 24/7.
      </p>
    </div>
  );
};

export default SignedOutIntroCTA;
